import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { StatCard } from "../../../components/dashboard/stat-card";
import { Users, Calendar, TrendingUp, MapPin } from "lucide-react";
import { useOutreachStats } from "../hooks/useOutreachStats";
import { OutreachMap } from "./OutreachMap";
import { OutreachMetrics } from "./OutreachMetrics";

export function OutreachDashboard() {
  const { data: stats, isLoading } = useOutreachStats();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-foreground">Outreach Overview</h1>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        <StatCard
          title="Active Programs"
          value={stats?.activePrograms.toString() || "0"}
          subtitle="Currently running"
          icon={Calendar}
          variant="primary"
          isLoading={isLoading}
        />
        <StatCard
          title="Total Participants"
          value={stats?.totalParticipants.toString() || "0"}
          subtitle="Year to date"
          icon={Users}
          variant="success"
          isLoading={isLoading}
        />
        <StatCard
          title="Locations"
          value={stats?.locations.toString() || "0"}
          subtitle="Communities served"
          icon={MapPin}
          variant="warning"
          isLoading={isLoading}
        />
        <StatCard
          title="Success Rate"
          value={`${stats?.successRate || 0}%`}
          subtitle="Program completion"
          icon={TrendingUp}
          variant="primary"
          isLoading={isLoading}
        />
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <Card className="border-0 shadow-md">
          <CardHeader className="border-b bg-muted/50">
            <CardTitle className="text-foreground">Program Locations</CardTitle>
          </CardHeader>
          <CardContent className="p-6">
            <div className="aspect-[4/3]">
              <OutreachMap />
            </div>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-md">
          <CardHeader className="border-b bg-muted/50">
            <CardTitle className="text-foreground">Performance Metrics</CardTitle>
          </CardHeader>
          <CardContent className="p-6">
            <OutreachMetrics />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
